import { defineMessages } from 'react-intl';

export default defineMessages({
  sectionHeader: {
    id: 'fastCover.rentalCarProtectionTravellerTugo.sectionHeader',
    defaultMessage: 'This section relates to the physical damage to a rented or leased automobile anywhere in the world while the automobile is in your care, custody or control. This coverage has conditions, limitations and exclusions; please refer to your policy booklet for details.',
  },
  rentalCarItems: {
    id: 'fastCover.rentalCarProtectionTravellerTugo.rentalCarItems',
    defaultMessage: 'Rental car expenses',
  },
  isRequired: {
    id: 'fastCover.rentalCarProtectionTravellerTugo.isRequired',
    defaultMessage: '{fieldName} is required',
  },
  carRentalStartDate: {
    id: 'fastCover.rentalCarProtectionTravellerTugo.carRentalStartDate',
    defaultMessage: 'Car Rental Start Date',
  },
  carRentalEndDate: {
    id: 'fastCover.rentalCarProtectionTravellerTugo.carRentalEndDate',
    defaultMessage: 'Car Rental End Date',
  },
  pickUpLocation: {
    id: 'fastCover.rentalCarProtectionTravellerTugo.pickUpLocation',
    defaultMessage: 'Car Rental Pick Up Location',
  },
  dropOffLocation: {
    id: 'fastCover.rentalCarProtectionTravellerTugo.dropOffLocation',
    defaultMessage: 'Car Rental Drop Off Location',
  },
  nameOfDriver: {
    id: 'fastCover.rentalCarProtectionTravellerTugo.nameOfDriver',
    defaultMessage: 'Name of Driver',
  },
  authorityToWhomReported: {
    id: 'fastCover.rentalCarProtectionTravellerTugo.authorityToWhomReported',
    defaultMessage: 'Authority to whom accident was reported',
  },
  describeAccident: {
    id: 'fastCover.rentalCarProtectionTravellerTugo.describeAccident',
    defaultMessage: 'Describe how the accident occurred',
  },
  causedByAnotherParty: {
    id: 'fastCover.rentalCarProtectionTravellerTugo.causedByAnotherParty',
    defaultMessage: 'Was this accident caused by another party?',
  },
  yes: {
    id: 'fastCover.rentalCarProtectionTravellerTugo.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.rentalCarProtectionTravellerTugo.no',
    defaultMessage: 'No',
  },
  responsiblePartyInfo: {
    id: 'fastCover.rentalCarProtectionTravellerTugo.responsiblePartyInfo',
    defaultMessage: "Responsible Party's name and complete insurance information",
  },
});




// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.RentalCarProtectionTraveller/messages.js